export const SEARCH_CLASS_BANNERS = 'classBannerSearch/SEARCH_CLASS_BANNERS'
